import service from '@/utils/request'

export function getSupplierPageGtZero(params) {
  const requestParams = {
    supplierName: params?.supplierName || '',
    current: params?.current || 1,
    size: params?.size || 20
  }
  // 按供应商 ID 精确查询（备料标签扫码场景）
  if (params?.id || params?.supplierId) {
    requestParams.id = params.id || params.supplierId
  }
  return service.get('/uic-system/supplier/pageGtZero', {
    params: requestParams
  })
}

export function getWareList(params) {
  return service.get('/uic-system/ware/list', {
    params: {
      wareType: 0,
      bizDept: params?.bizDept
    }
  })
}

export function getMaterialPage(params) {
  return service.get('/uic-system/material/page', {
    params: {
      current: params?.current || 1,
      size: params?.size || 20,
      supplierId: params?.supplierId,
      storeId: params?.storeId,
      materialNo: params?.materialNo || '',
      isBad: params?.isBad ?? 0,
      isCompose: params?.isCompose ?? 0
    }
  })
}

export function submitWareIn(data) {
  return service.post('/uic-system/warein/submit', data)
}
